import { WorkspaceDropdownInfo } from "./types";

export function getWorkspaceDisplayName(workspace: WorkspaceDropdownInfo) {
  return workspace.displayName || workspace.name;
}

export function getWorkspaceInitial(workspace: WorkspaceDropdownInfo) {
  return (getWorkspaceDisplayName(workspace) || "w").charAt(0).toUpperCase();
}
